export const VERSION = {
  PROD: 'V. 3.6.0',
  QA: 'V. 5.1.0 (QA)',
}
